import { useState, useEffect, useCallback } from "react";
import { useSave, useFetch } from "../../../components/Hooks/Conexao";
import Mensagens from "../../../components/Mensagens";
import * as api from "./CadastrosApi";

export function useCadastro(fetch, modelo, config = {}, all, isPk) {
  const [txt, setTxt] = useState("");
  const [id, setId] = useState(null);
  const [list, listar, isLoading, setList] = useFetch(() => api.getAll(fetch, modelo, txt, all));
  const [object, buscarObject, isLoadingObject, setObject] = useFetch(() => api.getById(fetch, modelo, isPk, id), null, { onRejected: v => { Mensagens.showErro(v); setId(null); } });
  const [del, isDeleting] = useSave();

  const [save, isSaving] = useSave(
    () => api.save(fetch, modelo, object),
    obj => {
      if (!!config?.onOk)
        config?.onOk(obj);

      if (!!config.reloadPesq)
        config.reloadPesq(modelo, null);

      setId(null);
      setObject(null);
      listar();
      Mensagens.showSucesso("Salvo com sucesso!");
    }
  );

  const salvarObj = obj => save(() => api.save(fetch, modelo, obj), () => {
    setId(null);
    setObject(null);
    listar();
  });


  const cancelEdit = () => {
    setId(null);
    setObject(null);
  };

  const remove = (id) => {
    del(() => api.del(fetch, modelo, id), () => {
      listar();
      if (!!config.onRemove) config.onRemove(id);
      if (!!config.reloadPesq) config.reloadPesq(modelo, null);
    });
  };

  useEffect(() => { if (id) buscarObject(); }, [id]);
  useEffect(() => {
    if (!config.disableListar)
      listar();
  }, [txt]);

  const onSetId = useCallback(d => setId(d?.id), [list]);
  const onRemove = useCallback(d => remove(d?.id), [list]);

  return { setTxt, setId: onSetId, object, setObject, cancelEdit, list, setList, loading: isLoading || isLoadingObject || isSaving || isDeleting, save, remove: onRemove, salvarObj };
}
